import React, {useState} from 'react';
import 'contents/assets/scss/page/data.scss';
import Tab from '../../component/Inc/Tab';
import Paging from '../../component/Inc/Paging';

function EasyPotList() {
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '국어', value: 0},
    {title: '영어', value: 1},
    {title: '수학', value: 2},
    {title: '과탐', value: 3},
    {title: '사탐', value: 4},
    {title: '수시', value: 5}
  ];
  return (
    <main className="com_container p_easypot_list">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu4_6">이지팟 문제은행 목록</h2>
          <button className="com_btn orange s btn_plus">문제 유형 등록</button>
        </section>
        <section className="com_pg_container">
          <section className="box box-half">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <div className="com_input_wrap">
                <select className="select xs">
                  <option value="유출 년도 선택">유출 년도 선택</option>
                </select>
                <select className="select xs">
                  <option value="학년 선택">학년 선택</option>
                </select>
              </div>

              <section className="com_board_search end">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="8%" />
                <col width="10%" />
                <col width="9%" />
                <col width="10%" />
                <col width="9%" />
                <col width="9%" />
                <col width="9%" />
              </colgroup>
              <thead>
                <tr>
                  <th>과목</th>
                  <th>총문제 수</th>
                  <th>수능 / 학평</th>
                  <th>미분류</th>
                  <th>스캔</th>
                  <th>해설</th>
                  <th>문제은행</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>국어</td>
                  <td>650,000</td>
                  <td>64,133</td>
                  <td>2,454</td>
                  <td>650,000</td>
                  <td>2,454</td>
                  <td>
                    <button className="btn_link blue">보기</button>
                  </td>
                </tr>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>국어</td>
                      <td>650,000</td>
                      <td>64,133</td>
                      <td>2,454</td>
                      <td>650,000</td>
                      <td>2,454</td>
                      <td>
                        <button className="btn_link blue">보기</button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Paging />
          </section>
          <section className="box box-half type_column">
            <div className="detail_tit dot">문제 유형</div>
            <div className="board_select">
              <div className="com_input_wrap flex_row">
                <select className="select xs">
                  <option value="교재 영역 선택">교재 영역 선택</option>
                </select>
                <select className="select xs">
                  <option value="교재 선택">교재 선택</option>
                </select>
              </div>
              <div className="com_input_wrap flex_row">
                <select className="select xs">
                  <option value="유출년도 선택">유출년도 선택</option>
                </select>
                <select className="select xs">
                  <option value="학년 선택">학년 선택</option>
                </select>
              </div>
            </div>
            <div className="question_wrap">
              <div className="com_info gray">
                <div className="txt">
                  <i className="icon_arrow_right_white"></i>
                  <strong className="bold">대단원 / 중단원/ 유형 (수직적 분류 방식)</strong>
                </div>
                <div className="count">
                  <button className="btn btn_edit" />
                </div>
              </div>
              <div className="question_list">
                <div className="depth1">
                  <div className="com_info">
                    <div className="txt">
                      <strong className="bold">1. 듣기</strong>
                    </div>
                    <div className="count">
                      <button className="btn btn_edit" />
                      <button className="btn icon_arrow_down" />
                    </div>
                  </div>
                </div>
                <div className="depth2">
                  <div className="com_info">
                    <div className="txt">
                      <strong className="bold">1. 화법</strong>
                    </div>
                    <div className="count">
                      <button className="btn btn_edit" />
                      <button className="btn icon_arrow_down" />
                    </div>
                  </div>
                </div>
                <div className="depth3">
                  <div className="com_info line">
                    <div className="txt">
                      <strong className="bold">1. 화법의 특성</strong>
                    </div>
                    <div className="count">
                      <span className="com_icon darkGray xxs">68문제</span>
                      <button className="btn btn_edit" />
                      <button className="btn btn_close_x" />
                    </div>
                  </div>
                  <div className="com_info line">
                    <div className="txt">
                      <strong className="bold">2. 화법의 특성</strong>
                    </div>
                    <div className="count">
                      <span className="com_icon darkGray xxs">68문제</span>
                      <button className="btn btn_edit" />
                      <button className="btn btn_close_x" />
                    </div>
                  </div>
                  <div className="com_info line">
                    <div className="txt">
                      <strong className="bold">No.</strong>
                    </div>
                    <div className="count">
                      <button className="com_btn orange btn_plus">추가</button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="question_list">
                <div className="com_info">
                  <div className="txt">
                    <strong className="bold">No.</strong>
                  </div>
                  <div className="count">
                    <button className="com_btn orange btn_plus">추가</button>
                  </div>
                </div>
              </div>

              <div className="com_info gray">
                <div className="txt">
                  <i className="icon_arrow_right_white"></i>
                  <strong className="bold">중단원 / 중단원/ 유형 (수직적 분류 방식)</strong>
                </div>
                <div className="count">
                  <button className="com_btn orange btn_plus">추가</button>
                </div>
              </div>
            </div>

            <div className="com_btn_wrap center bottom">
              <div className="com_btn orange xs wl">저장</div>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
}

export default EasyPotList;
